import { render, staticRenderFns } from "./PluginSettingsAvalara.vue?vue&type=template&id=9cf58dda&"
import script from "./PluginSettingsAvalara.vue?vue&type=script&lang=ts&"
export * from "./PluginSettingsAvalara.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports